import { render } from "./background_check.vue?vue&type=template&id=5754648c"
import script from "./background_check.vue?vue&type=script&lang=js"
export * from "./background_check.vue?vue&type=script&lang=js"

import "./background_check.vue?vue&type=style&index=0&id=5754648c&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__